import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../shared/base-components/base.component';
import { InsuranceSearchResultModel } from '../../titleregistration/models/insurance-search-result.model';
import { InsuranceService } from '../../titleregistration/services/insurance.service';
import { CustomerInsuranceInfo } from '../models/customer-insurance-info.model';
import { InsurancePolicySourceType } from '../../titleregistration/models/enums/insurance-policy-source-type.enum';
import { InsurancePolicyType } from '../../titleregistration/models/enums/insurance-policy-type.enum';

@Component({
    selector: 'customer-insurance',
    templateUrl: './customer-insurance.html',
    inputs: ['customerNumber']
})

export class CustomerInsuranceComponent extends BaseComponent {

    // Gets or sets the insurance policy source type enums
    public InsurancePolicySourceTypes = new InsurancePolicySourceType();

    // Gets or sets the insurance policy type enums
    public InsurancePolicyTypes = new InsurancePolicyType();

    // Gets or sets the insurance policies
    public insurancePolicies: CustomerInsuranceInfo[];

    // Gets or sets the customerNumber Id
    public customerNumber: number;

    /**
     * Constructor
     * @param insuranceService The insurance service
     * @param router The angular router instance
     */
    constructor(
        private insuranceService: InsuranceService,
        private router: Router) {
        super();
    }

    /**
     * Inits the angular page
     * */
    ngOnInit() {
        this.getInsurancePolicyInformation();
    }

    /**
     * Gets the insurance policy information
     * */
    private getInsurancePolicyInformation() {
        this.insuranceService.getInsuranceSearchResultsByCustomerNumberId(this.customerNumber).subscribe(
            result => this.setInsurance(result),
            error => this.handleValidationResult(error));
    }

    /**
     * Creates the insurance policy objects
     * @param results The insurance search results to be used to generate the customer insurance info
     */
    private setInsurance(results: InsuranceSearchResultModel[]) {
        this.insurancePolicies = results.map(result => {
            let insurancePolicy = new CustomerInsuranceInfo();
            insurancePolicy.policyId = result.id;
            insurancePolicy.adotCode = result.adotCode;
            insurancePolicy.companyName = result.insuranceCompanyName;
            insurancePolicy.policyNumber = result.insurancePolicyNumber;
            insurancePolicy.policySourceTypeId = result.insurancePolicySourceTypeId;
            insurancePolicy.policySourceType = this.getInsurancePolicySourceType(result.insurancePolicySourceTypeId),
            insurancePolicy.policyTypeId = result.insurancePolicyTypeId;
            insurancePolicy.policyType = this.getInsurancePolicyType(result.insurancePolicyTypeId),
            insurancePolicy.policyHolder = result.customer ? result.customer.customerName : null;
            insurancePolicy.notifyDate = result.notifyDate;
            insurancePolicy.effectiveDate = result.effectiveDate;
            insurancePolicy.endDate = result.endDate;
            insurancePolicy.vehicleId = result.vehicleId;
            insurancePolicy.insurancePolicyVehicleId = result.insurancePolicyVehicleId;
            insurancePolicy.notifyDate = result.notifyDate;

            return insurancePolicy;
        });
    }

    /**
     * Gets the insurance policy type
     * @param insurancePolicyTypeId The insurance policy type id
     */
    public getInsurancePolicyType(insurancePolicyTypeId: number) {
        let displayValue = this.InsurancePolicyTypes.FromId(insurancePolicyTypeId).displayValue;
        if (null == displayValue) {
            throw `Template type ${insurancePolicyTypeId} is missing.`;
        }

        return displayValue;
    }

    /**
     * Gets the insurance policy status type
     * @param insurancePolicySourceTypeId The insurance policy statust type id
     */
    public getInsurancePolicySourceType(insurancePolicySourceTypeId: number) {
        let displayValue = this.InsurancePolicySourceTypes.FromId(insurancePolicySourceTypeId).displayValue;
        if (null == displayValue) {
            throw `Template type ${insurancePolicySourceTypeId} is missing.`;
        }

        return displayValue;
    }

    /**
     * Handles the add insurance policy event
     * */
    public addInsurancePolicy() {

    }

    /**
     * Handles the show insurance policy history event
     * @param customerNumberId The customer number of the customer to display history for
     */
    public showHistory(customerNumberId: number) {
        this.router.navigate([`/customer/customer-insurance/${customerNumberId}`]);
    }
}
